<!-- src/app/components/layout/SubFooter.vue -->
<template>
  <!-- 자료 담당자 -->
  <div class="cont_manager">
    <dl class="tel">
      <dt>전화번호</dt>
      <dd>{{ menuInfo?.managerTel || managerTel || '-' }}</dd>
    </dl>
    <dl class="update">
      <dt>최근자료수정일</dt>
      <dd>{{ displayModDate || '-' }}</dd>
    </dl>
  </div>
  <!-- // 자료 담당자 -->

  <!-- 컨텐츠 평가 -->
  <div class="cont_rating">
    <div class="inr">
      <h2>현재페이지의 내용과 사용편의성에 만족하십니까?</h2>
      <div class="inp_area">
        <fieldset>
          <legend>사용편의성 만족도</legend>
          <span>
            <input id="cmt1" v-model="selectedPoint" type="radio" value="5" name="satisfaction_chk" class="inp_rdo">
            <label for="cmt1">매우 만족</label>
          </span>
          <span>
            <input id="cmt2" v-model="selectedPoint" type="radio" value="4" name="satisfaction_chk" class="inp_rdo">
            <label for="cmt2">만족</label>
          </span>
          <span>
            <input id="cmt3" v-model="selectedPoint" type="radio" value="3" name="satisfaction_chk" class="inp_rdo">
            <label for="cmt3">보통</label>
          </span>
          <span>
            <input id="cmt4" v-model="selectedPoint" type="radio" value="2" name="satisfaction_chk" class="inp_rdo">
            <label for="cmt4">불만족</label>
          </span>
          <span>
            <input id="cmt5" v-model="selectedPoint" type="radio" value="1" name="satisfaction_chk" class="inp_rdo">
            <label for="cmt5">매우 불만족</label>
          </span>

          <!-- 기존 onclick -> Vue 방식으로 변경 -->
          <button
              type="button"
              class="btn_rate"
              :disabled="!domainId || !menuId || !selectedPoint"
              @click="onRate"
          >
            평가하기
          </button>
        </fieldset>
      </div>
    </div>
  </div>
  <!-- //컨텐츠 평가 -->
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { procSatis, getMenuInfoDetail } from '@/service/common.service'
import { useAlert } from '@/composables/useAlert'
const { showAlert } = useAlert()

defineOptions({name: 'SubFooter'})

const props = defineProps({
  menuId: {
    type: String,
    default: ''
  },
  managerTel: {
    type: String,
    default: ''
  },
  formattedModDate: {
    type: String,
    default: ''
  }
})

const domainId = computed(() => import.meta.env.VITE_DOMAIN_ID || '')
const selectedPoint = ref('')

const toYmd = (value) => {
  if (!value) return ''
  const str = String(value)
  const match = str.match(/^\d{4}-\d{2}-\d{2}/)
  return match ? match[0] : ''
}

const displayModDate = computed(() => {
  return toYmd(menuInfo.value?.updtDt) || toYmd(props.formattedModDate)
})

// 메뉴 상세 정보 조회
const menuInfo = ref(null)
const fetchMenuInfo = async () => {
  if (!domainId.value || !props.menuId) return

  try {
    const res = await getMenuInfoDetail({ dmnId: domainId.value, menuId: props.menuId })
    menuInfo.value = res?.data || null
  } catch (e) {
    menuInfo.value = null
  }
}

onMounted(() => {
  fetchMenuInfo()
})

watch(
  () => props.menuId,
  () => {
    fetchMenuInfo()
  },
  { immediate: true }
)

// 평가 처리
const onRate = async () => {
  if (!selectedPoint.value) {
    await showAlert('만족도를 체크해주시기 바랍니다.')
    return
  }

  const params = {
    dmnId: domainId.value,
    menuId: props.menuId,
    point: Number(selectedPoint.value)
  }

  try {
    const res = await procSatis(params)
    if (res?.result) {
      await showAlert(res?.message || '의견이 정상적으로 반영되었습니다. 감사합니다.')
      selectedPoint.value = ''
    } else {
      if (res?.code === 'INVALID_ARGUMENT') {
        await showAlert(res?.message || '이미 평가가 완료된 사용자입니다.')
        selectedPoint.value = ''
        return
      }
      await showAlert(res?.message || '데이터 입력도중 에러가 발생하였습니다. 다시 한번 시도해 주시기 바랍니다.')
    }
  } catch (e) {
    await showAlert(e?.serverMessage || e?.message || '평가 등록 중 오류가 발생했습니다.')
  }
}
</script>
